import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">联系我们</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">如有任何问题、建议或商业合作意向，欢迎通过以下方式与我们取得联系</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-center hover:border-primary-200 transition-all duration-300">
            <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center">
              <i className="ri-mail-line text-2xl text-primary-600"></i>
            </div>
            <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">电子邮件</h3>
            <p className="text-foreground-500 text-sm break-all">{contactData.email}</p>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-center hover:border-primary-200 transition-all duration-300">
            <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-accent-100 flex items-center justify-center">
              <i className="ri-wechat-line text-2xl text-accent-600"></i>
            </div>
            <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">微信公众号</h3>
            <p className="text-foreground-500 text-sm">{contactData.wechat}</p>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-center hover:border-primary-200 transition-all duration-300">
            <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-secondary-100 flex items-center justify-center">
              <i className="ri-weibo-line text-2xl text-secondary-600"></i>
            </div>
            <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">官方微博</h3>
            <p className="text-foreground-500 text-sm">{contactData.weibo}</p>
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-foreground-500 text-sm">
            我们的客服团队工作日 9:00-18:00 在线，通常在 <strong className="text-primary-600">2小时内</strong> 回复您的咨询。
          </p>
        </div>
      </div>
    </section>
  );
}